import { useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import "../../../UserDashboard/components/UserDashboardHome/UserDashboardHome.css";
import localeText from "../../../../locale";
import { Toast } from "primereact/toast";
import "../../../UserDashboard/components/StatementTable/StatementTable.css";
import { Column } from "primereact/column";
import TypeService from "../../../../service/TypeService";
import { FilterMatchMode } from "primereact/api";
import { Button } from "primereact/button";
import NewType from "../NewType/NewType";

const ListType = () => {
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [descriptionEnglish, setDescriptionEnglish] = useState("");
  const [descriptionItalian, setDescriptionItalian] = useState("");
  const [descriptionPortuguese, setDescriptionPortuguese] = useState("");
  const [descriptionSpanish, setDescriptionSpanish] = useState("");
  const [id, setId] = useState("");

  const typeService = new TypeService();
  const toast = useRef(null);
  const newTypeRef = useRef(null);

  useEffect(() => {
    let cancel = false;

    async function fetchData() {
      try {
        setLoading(true);

        const res = await typeService.getType(localStorage.getItem("__extraconomy_token"));

        if (cancel) return;

        if (res.messageCode !== 200001) {
          toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
            life: 6000,
          });
          if (res.messageCode === 500000) console.log(res);
          setLoading(false);
        } else {
          setType(res.result);
          setLoading(false);
        }
      } catch (e) {
        if (e.status === 401 || e.status === 403) {
          localStorage.removeItem("__extraconomy_token");
          //  localStorage.removeItem('__extraconomy_username')
          window.location.replace("/login");
        }
        setLoading(false);
        console.log(e);
      }
    }

    fetchData();

    return () => {
      cancel = true;
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filters2 = {
    descriptionEnglish: { value: null, matchMode: FilterMatchMode.CONTAINS },
    descriptionItalian: { value: null, matchMode: FilterMatchMode.CONTAINS },
    descriptionSpanish: { value: null, matchMode: FilterMatchMode.CONTAINS },
    descriptionPortuguese: { value: null, matchMode: FilterMatchMode.CONTAINS },
  };

  return (
    <div className="card border-1 border-300">
      <Toast ref={toast} />

      <h3 className="my-4">{localeText("typesCategoriesRegistered")}</h3>

      <hr />

      <DataTable
        className="mt-4 mb-6 p-datatable-customers"
        value={type}
        paginator
        responsiveLayout="scroll"
        loading={loading}
        dataKey="id"
        filterDisplay="row"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate={localeText("showingFirstToLast")}
        rows={10}
        rowsPerPageOptions={[10, 20, 50]}
      >
        <Column
          field="descriptionEnglish"
          header={localeText("descriptionTypeEN")}
          filter
          filters={filters2}
          filterDisplay="row"
          style={{ width: "20%" }}
          body={(types) => {
            return <span>{types.descriptionEnglish}</span>;
          }}
        />
        <Column
          field="descriptionItalian"
          header={localeText("descriptionTypeIT")}
          filter
          filters={filters2}
          filterDisplay="row"
          style={{ width: "20%" }}
          body={(types) => {
            return <span>{types.descriptionItalian}</span>;
          }}
        />
        <Column
          field="descriptionPortuguese"
          header={localeText("descriptionTypePT")}
          filter
          filters={filters2}
          filterDisplay="row"
          style={{ width: "20%" }}
          body={(types) => {
            return <span>{types.descriptionPortuguese}</span>;
          }}
        />
        <Column
          field="descriptionSpanish"
          header={localeText("descriptionTypeES")}
          filter
          filters={filters2}
          filterDisplay="row"
          style={{ width: "20%" }}
          body={(types) => {
            return <span>{types.descriptionSpanish}</span>;
          }}
        />
        <Column
          field="descriptionES"
          header={localeText("edit")}
          style={{ width: "20%" }}
          body={(type) => {
            return (
              <Button
                icon="pi pi-pencil"
                onClick={() => {
                  setIsEdit(false);
                  setDescriptionEnglish(type.descriptionEnglish);
                  setDescriptionItalian(type.descriptionItalian);
                  setDescriptionPortuguese(type.descriptionPortuguese);
                  setDescriptionSpanish(type.descriptionSpanish);
                  setId(type.id);
                  setIsEdit(true);

                  setTimeout(() => newTypeRef.current.scrollIntoView({ behavior: "smooth" }), 100);
                }}
                style={{ textSize: "4em" }}
              />
            );
          }}
        />
      </DataTable>
      <div ref={newTypeRef} id="NewCategories">
        {isEdit && (
          <NewType
            descriptionEN={descriptionEnglish}
            descriptionES={descriptionSpanish}
            descriptionIT={descriptionItalian}
            descriptionPT={descriptionPortuguese}
            id={id}
            isEdit={isEdit}
          />
        )}
      </div>
    </div>
  );
};

export default ListType;
